import { Injectable } from '@angular/core';

import { ApAnalyticsService, ClickAnalyticsData } from '@ap/analytics';

@Injectable({ providedIn: 'root' })
export class MijnTemplateAnalyticsService {
    public constructor(private readonly analyticsService: ApAnalyticsService) {}

    public clickEvent(element: string, action: string): void {
        const clickAnalyticsData: ClickAnalyticsData = new ClickAnalyticsData(element, action);
        this.analyticsService.push(clickAnalyticsData);
    }
}
